export const SET_SUMMARIES = 'SET_SUMMARIES';



// WEBPACK FOOTER //
// ./src/actionTypes/summariesActionTypes.js